exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.company[data-v-db2305ca] {\n  background: #ffffff;\n  padding: 30px;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n  margin-bottom: 15px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.company .name[data-v-db2305ca] {\n    font-weight: 600;\n}\n.company .action[data-v-db2305ca] {\n    background: #172b43;\n    color: #ffffff;\n    padding: 4px 10px;\n    border-radius: 3px;\n    cursor: pointer;\n}\n.company .action[data-v-db2305ca]:hover {\n      opacity: 0.9;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-db2305ca","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/components/changeCompany.vue
// module id = 590
// module chunks = 0